import React, { useMemo } from 'react';
import { MachineView } from './machine/MachineView';
import { FleetPageContainer } from './FleetPage.elements';
import { PageHeader } from './components/PageHeader/PageHeader';
import { MachineInfoProvider, useMachineInfo } from './providers';
 
import { showCounters } from './testing_settings';
import { useFleetRouter } from './hooks/useFleetRouter';
import { AccountInfoProvider } from './providers/useAccountInfoProvider';
import { InformationBar } from './components/InformationBar/InformationBar';
import { InformationBarProvider } from './providers/InformationBarProvider';
import { LineView } from './line/LineView';
import { LineInfoProvider } from './line/providers/useLineInfoProvider';
import { SiteView } from './site/SiteView';
 

//-----------------------------------
// NOTES:
// Look into having a customer info provider that has the customer info and the account info
// and timezone
// businessUnit is not required as the page gets the BU from the account info provider
//-----------------------------------

const Provided = () => {
  const { businessUnit: bu } = useMachineInfo();
  return bu === 'aseptic' || bu === 'dsi' || bu === 'stnik' || bu === 'marel' ? (
    <InformationBarProvider bu={bu}>
      <InformationBar />
      <PageHeader />
      <MachineView />
    </InformationBarProvider>
  ) : (
    <>
      <PageHeader />
      <MachineView />
    </>
  );
}

const MachineViewComponent = () => (
  <AccountInfoProvider>
    <MachineInfoProvider>
      <Provided />
    </MachineInfoProvider>
  </AccountInfoProvider>
);

const LineViewComponent = () => (
  <LineInfoProvider>
    <LineView />
  </LineInfoProvider>
);

let FleetPage_PageRoutes_counter = 0;

export const FleetPage = (): JSX.Element => {
  const [{ page }] = useFleetRouter();
  if (showCounters) console.log({ FleetPage_PageRoutes_counter });

 
  const cachedRoutes = useMemo(() => {
    ++FleetPage_PageRoutes_counter;
    switch (page) {
      case 'machine':
        return <MachineViewComponent />;
      case 'line':
        return <LineViewComponent />;
      case 'site':
        return <SiteView />;
      case 'dashboard':
        return <div>dashboard</div>;
      default:
        return <div>Fleet Page 404</div>;
    }
  }, [page]);

  return <FleetPageContainer>{cachedRoutes}</FleetPageContainer>;
};
